import { render, staticRenderFns } from "./notFullBankPayments.vue?vue&type=template&id=f55a47ee&"
import script from "./notFullBankPayments.vue?vue&type=script&lang=js&"
export * from "./notFullBankPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports